// CSS
import '../scss/index.scss';

// Polyfills
import './lib/polyfills';

// Vendors
import $ from 'jquery';
import 'fancybox/dist/js/jquery.fancybox.pack';
import 'jquery.maskedinput/src/jquery.maskedinput';
import './lib/wl-share';

// Framework
import carousels from './framework/carousel';
import code from './framework/code';
import dropdowns from './framework/dropdown';
import modals from './framework/modal';
import notices from './framework/notice';
import toggles from './framework/toggle';
import tooltips from './framework/tooltip';
import utilities from './framework/utilities';

// Site modules
import './site/aos';
import './site/scrolling-grid';
import './site/back-to-top';
import './site/home-animation';
import './site/mobile-nav';
import './site/newsroom';
import './site/header-search';
import './site/search-autosuggest';
import './site/side-nav';
import './site/sticky-header';
import './site/hero-parallax';
import './site/parallax-cards';
import './site/video-modals';
import './site/youtube-video';
import './site/video-block';
import './site/steps-block';
import './site/video-row';

// Apply input masks
$('.mask-input-phone').mask('(999) 999-9999');
$('.mask-input-date').mask('99/99/9999');

// Init Fancybox
$('.fancybox').fancybox({
  helpers: {
    overlay: {
      locked: false // Prevent page from jumping back to top
    }
  }
});

// Init card media carousel (image collages on story cards)
const carouselCardMedia = carousels('[data-carousel="card-media"]', {
  autoplay: false,
  dots: true,
  arrows: false,
  infinite: true,
  speed: 400
});

// Init single carousel
const carouselSingle = carousels('[data-carousel="single"]', {
  autoplay: false,
  dots: true,
  infinite: true,
  speed: 500
});

// Init multiple carousel
const carouselMultiple = carousels('[data-carousel="multiple"]', {
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
});

// Init timeline carousel
const carouselTimelineLg = carousels('[data-carousel="timeline_lg"]', {
  autoplay: false,
  dots: false,
  arrows: true,
  asNavFor: '.carousel-dot-container-lg',
  infinite: false,
  slidesToShow: 2,
  slidesToScroll: 1,
  speed: 1100
});

const carouselTimelineNavLg = carousels('[data-carousel="timeline_nav_lg"]', {
  slidesToShow: 13,
  slidesToScroll: 1,
  asNavFor: '.timeline-carousel-lg',
  centerMode: false,
  focusOnSelect: true,
  arrows: false,
  infinite: false,
  responsive: [
    {
      breakpoint: 1330,
      settings: {
        slidesToShow: 8
      }
    }
  ]
});

const carouselTimelineSm = carousels('[data-carousel="timeline_sm"]', {
  autoplay: false,
  dots: false,
  arrows: false,
  asNavFor: '.carousel-dot-container-sm',
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 500
});

const carouselTimelineNavSm = carousels('[data-carousel="timeline_nav_sm"]', {
  slidesToShow: 4,
  slidesToScroll: 2,
  asNavFor: '.timeline-carousel-sm',
  centerMode: false,
  focusOnSelect: true,
  arrows: false,
  infinite: false
});

const logoSliderLg = carousels('[data-carousel="logo-slider-lg"]', {
  autoplay: true,
  dots: false,
  arrows: false,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplaySpeed: 0,
  speed: 4000,
  cssEase: 'linear',
  draggable: false,
  swipe: false,
  pauseOnFocus: false,
  pauseOnHover: false
});

const logoSliderMd = carousels('[data-carousel="logo-slider-md"]', {
  autoplay: true,
  dots: false,
  arrows: false,
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplaySpeed: 0,
  speed: 7000,
  cssEase: 'linear',
  draggable: false,
  swipe: false,
  pauseOnFocus: false,
  pauseOnHover: false
});

const logoSliderSm = carousels('[data-carousel="logo-slider-sm"]', {
  autoplay: true,
  dots: false,
  arrows: false,
  infinite: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  autoplaySpeed: 0,
  speed: 7000,
  cssEase: 'linear',
  draggable: false,
  swipe: false,
  pauseOnFocus: false,
  pauseOnHover: false
});

// Init Hero Carousel
const heroHomeSlider = carousels('[data-carousel="hero-home"]', {
  autoplay: true,
  dots: true,
  autoplaySpeed: 7000,
  infinite: true,
  cssEase: 'linear',
  speed: 800,
  arrows: false,
  pauseOnFocus: false,
  pauseOnHover: false
});

const $homeSliderNew = $('[data-carousel="home-new"]');

function resetAnimations($slide) {
  // $slide.find('[data-animate]').css({
  //   opacity: 0,
  //   transform: 'translateY(20px)',
  //   transitionDelay: '0s'
  // });
  $slide.removeClass('animate-in');
}

/*
 * Hero slide background videos.
 *
 * The slider fades rather than slides, so every slide stays in the DOM the whole
 * time. Without this only the first slide would ever be correct: the others would
 * be downloading and playing behind the one on screen.
 *
 * Nothing has a src until its slide is the active one — the markup carries
 * `data-src` (see partials/components/hero-video-background.php). That is also
 * what keeps the video off mobile: the panel is hidden under 768px, and the
 * breakpoint check below means a phone never requests the file at all.
 */
const heroVideoDesktop = window.matchMedia('(min-width: 769px)');
const heroVideoReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function heroVideoAllowed() {
  return heroVideoDesktop.matches && !heroVideoReducedMotion.matches;
}

// Provider embeds are paused through their postMessage API rather than by
// dropping the src, which would blank the panel mid-fade.
function postToHeroEmbed(iframe, message) {
  if (!iframe.contentWindow || !iframe.getAttribute('src')) {
    return;
  }

  iframe.contentWindow.postMessage(message, '*');
}

function startHeroVideo($slide) {
  if (!heroVideoAllowed()) {
    return;
  }

  $slide.find('.hero-slide__video-media').each((index, media) => {
    const src = media.getAttribute('data-src');

    if (src && !media.getAttribute('src')) {
      media.setAttribute('src', src);

      // A <video> that was preload="none" needs a nudge to pick up the new source.
      if ('VIDEO' === media.tagName) {
        media.load();
      }
    }

    if ('VIDEO' === media.tagName) {
      // Autoplay can still be refused (a battery-saver mode, say). The panel just
      // keeps showing its poster, so there is nothing to recover from.
      const played = media.play();

      if (played && played.catch) {
        played.catch(() => {});
      }

      return;
    }

    if (src && src.indexOf('vimeo') > -1) {
      postToHeroEmbed(media, '{"method":"play"}');
    } else {
      postToHeroEmbed(media, '{"event":"command","func":"playVideo","args":""}');
    }
  });
}

function stopHeroVideo($slide) {
  $slide.find('.hero-slide__video-media').each((index, media) => {
    if ('VIDEO' === media.tagName) {
      media.pause();

      return;
    }

    const src = media.getAttribute('src') || '';

    if (src.indexOf('vimeo') > -1) {
      postToHeroEmbed(media, '{"method":"pause"}');
    } else {
      postToHeroEmbed(media, '{"event":"command","func":"pauseVideo","args":""}');
    }
  });
}

function currentHeroSlide() {
  const slick = $homeSliderNew.length ? $homeSliderNew.slick('getSlick') : null;

  return slick ? $(slick.$slides.get(slick.currentSlide)) : $();
}

$homeSliderNew.on('init', function (event, slick) {
  const $firstSlide = $(slick.$slides.get(0));
  resetAnimations($firstSlide);
  startHeroVideo($firstSlide);
  setTimeout(() => $firstSlide.addClass('animate-in'), 50);
});

$homeSliderNew.on('beforeChange', function (event, slick, currentSlide) {
  const $outgoingSlide = $(slick.$slides.get(currentSlide));
  resetAnimations($outgoingSlide);
  stopHeroVideo($outgoingSlide);
});

$homeSliderNew.on('afterChange', function (event, slick, currentSlide) {
  const $currentSlide = $(slick.$slides.get(currentSlide));
  startHeroVideo($currentSlide);
  setTimeout(() => $currentSlide.addClass('animate-in'), 50);
});

// Init after events bound
$homeSliderNew.slick({
  dots: true,
  arrows: false,
  infinite: true,
  speed: 500,
  fade: true,
  cssEase: 'linear',
  autoplay: true,
  autoplaySpeed: 5000
});

// Crossing the breakpoint (a resize, or a phone turned sideways) has to settle the
// video on the slide that is already showing — otherwise it stays stopped until
// the next slide change, or keeps playing behind a panel that is now hidden.
if (heroVideoDesktop.addEventListener) {
  heroVideoDesktop.addEventListener('change', () => {
    const $slide = currentHeroSlide();

    if (heroVideoAllowed()) {
      startHeroVideo($slide);
    } else {
      stopHeroVideo($slide);
    }
  });
}

// Init modals
modals('[data-modal]');

// Init toggles
toggles('[data-toggle-target]');

// Init notices
notices('[data-notice-dismissible]');

// Init code
code('[data-code]');

// Init tooltips
tooltips('[data-tooltip]');

// Init dropdowns
dropdowns('[data-dropdown]');
